import { Divider, Grid, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { DeliveryFormType } from "../types";

interface Props {
  form: DeliveryFormType;
  oneDate?: boolean;
  disablePast?: boolean;
}

export function MissionDateSection({ form, oneDate = false, disablePast = true }: Props) {
  const { t } = useTranslation();

  const dateFields = oneDate
    ? [
        {
          name: "step0.carDeliveryDeadline" as const,
          label: t("delivery.form.car-delivery-deadline"),
        },
      ]
    : [
        {
          name: "step0.carAvailabilityDate" as const,
          label: t("delivery.form.car-availability-date"),
        },
        {
          name: "step0.carPickUpDate" as const,
          label: t("delivery.form.car-pick-up-date"),
        },
        {
          name: "step0.carDeliveryDeadline" as const,
          label: t("delivery.form.car-delivery-deadline"),
        },
      ];

  return (
    <Paper elevation={4} sx={paperSx}>
      <Grid container direction="row" spacing={2} paddingBottom={2}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="h5" textTransform="capitalize">
            {t("delivery.form.mission-date")}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Divider sx={dividerSx} />
        </Grid>

        {dateFields.map((df) => (
          <Grid size={{ xs: 12, lg: 12 / dateFields.length }} key={df.name}>
            <form.AppField
              name={df.name}
              listeners={
                df.name === "step0.carDeliveryDeadline" && oneDate
                  ? {
                      onChange: ({ value }) => {
                        form.setFieldValue("step0.carPickUpDate", value);
                        form.setFieldValue("step0.carAvailabilityDate", value);
                      },
                    }
                  : undefined
              }
            >
              {(field) => <field.DateTimeField label={df.label} disablePast={disablePast} />}
            </form.AppField>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}

const paperSx = { backgroundColor: "#E7E6F7", borderRadius: 1, padding: "20px", height: "100%" };
const dividerSx = { bgcolor: "#fe5d8d", marginBottom: 5 };
